// Globals
import React from 'react';
import { Image, ImageProps } from 'antd';

// Styles
import { StyledToolbar } from './ImageWithPreviewStyles';
import { ZoomInOutlined, ZoomOutOutlined } from '@ant-design/icons';

export type TImageWithPreview = ImageProps;

const ImageWithPreview = ({ ...props }: TImageWithPreview) => {
  return (
    <Image
      {...props}
      preview={{
        toolbarRender: (_, { transform: { scale }, actions: { onZoomIn, onZoomOut } }) => {
          return (
            <StyledToolbar>
              <ZoomOutOutlined disabled={scale === 1} onClick={onZoomOut} />
              <ZoomInOutlined disabled={scale === 50} onClick={onZoomIn} />
            </StyledToolbar>
          );
        },
      }}
    />
  );
};

export default ImageWithPreview;
